const ShowcasingDurations = [
    { value: "15", label: "15 minutter" },
	{ value: "30", label: "30 minutter" },
	{ value: "45", label: "45 minutter" },
	{ value: "60", label: "60 minutter" }
];

export default ShowcasingDurations;